module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/case-study-recognition-219a29da6d28e83be9e0ef0783752ca5.jpg";